/**
 * LBank timeframe configuration and interval mapping.
 * LBank uses format like 'minute1', 'minute5', 'hour1', 'day1'.
 * @see https://www.lbank.com/docs/#query-k-bar-data
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * LBank supported kline intervals.
 */
export const LBANK_TIMEFRAMES: TimeframeConfig = {
  native: [
    'minute1',
    'minute5',
    'minute15',
    'minute30',
    'hour1',
    'hour4',
    'hour8',
    'hour12',
    'day1',
    'week1',
    'month1',
  ],
  synthetic: ['1s'], // Use ticker for 1s
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('lbank', LBANK_TIMEFRAMES);

/**
 * Maps TradingView resolution to LBank interval format.
 */
export const mapToLbankInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds === 60) return 'minute1';
  if (seconds === 300) return 'minute5';
  if (seconds === 900) return 'minute15';
  if (seconds === 1800) return 'minute30';
  if (seconds === 3600) return 'hour1';
  if (seconds === 14400) return 'hour4';
  if (seconds === 28800) return 'hour8';
  if (seconds === 43200) return 'hour12';
  if (seconds === 86400) return 'day1';
  if (seconds === 604800) return 'week1';
  if (seconds === 2592000) return 'month1';

  // Default to closest supported interval
  if (seconds < 60) return 'minute1';
  if (seconds < 300) return 'minute1';
  if (seconds < 900) return 'minute5';
  if (seconds < 1800) return 'minute15';
  if (seconds < 3600) return 'minute30';
  if (seconds < 14400) return 'hour1';
  if (seconds < 28800) return 'hour4';
  if (seconds < 43200) return 'hour8';
  if (seconds < 86400) return 'hour12';
  if (seconds < 604800) return 'day1';
  if (seconds < 2592000) return 'week1';

  return 'month1';
};
